import { ISubmittedDocumentsStatusType } from 'APIPackage/CatalogsModule/interfaces/ISubmittedDocumentsStatusType';

import { ISubmittedDocumentsStatusTypeSelectOption } from '../interfaces/ISubmittedDocumentsStatusTypeSelectOption';

export const createSubmittedDocumentsStatusTypeSelectOption = (
  type: ISubmittedDocumentsStatusType,
): ISubmittedDocumentsStatusTypeSelectOption => ({
  ...type,
  label: type.title,
  value: type.code,
});
